import { ReactNode } from 'react'
import { cn } from '@/lib/utils/cn'

interface DetailPageLayoutProps {
  /** Main content area */
  children: ReactNode
  /** Sidebar content */
  sidebar?: ReactNode
  /** Grid layout columns (default: 'default' which is lg:grid-cols-3) */
  layout?: 'default' | 'two-column' | 'full-width'
  /** Additional CSS classes */
  className?: string
}

const layoutClasses = {
  default: 'grid grid-cols-1 lg:grid-cols-3 gap-6',
  'two-column': 'grid grid-cols-1 md:grid-cols-2 gap-6',
  'full-width': '',
}

const contentClasses = {
  default: 'lg:col-span-2',
  'two-column': '',
  'full-width': '',
}

export function DetailPageLayout({
  children,
  sidebar,
  layout = 'default',
  className,
}: DetailPageLayoutProps) {
  if (layout === 'full-width' || !sidebar) {
    return <div className={cn('space-y-6', className)}>{children}</div>
  }

  return (
    <div className={cn(layoutClasses[layout], className)}>
      <div className={cn('space-y-6', contentClasses[layout])}>{children}</div>
      {sidebar && <div className="space-y-6">{sidebar}</div>}
    </div>
  )
}
